module.exports = __webpack_public_path__ + "assets/hirewell-logo-short.45f1c9f8.png";